import { Routes } from '~/components/Routes'
import Vue from 'vue'
import { Component, Inject } from 'vue-property-decorator'
import { Util } from '~/components/Util'
import { Validation } from '~/components/Validation'
import '~/components/layouts/FullscreenWithCard.vue'
import FullscreenWithCard from '~/components/layouts/FullscreenWithCard'

@Component({
  head: Util.metaFields({
    title: 'Reset Your Password | EQUIAM'
  }),
  middleware: 'unauthenticated'
})
export default class ForgotPassword extends FullscreenWithCard {
  @Inject() routes!: Routes
  @Inject() validation!: Validation
  emailSent = false
  email = ''
  loading = false

  onSubmit() {
    (this.$refs.form as any).validate() && this.performReset()
  }

  performReset() {
    this.loading = true
    this.$axios.post('/auth/send-reset-password-email', { email: this.email })
      .then(() => this.emailSent = true)
      .catch(e => this.$store.commit('snacks/error', e))
      .finally(() => this.loading = false)
  }
}
